import { DefaultFacilityCard } from './DefaultFacilityCard'
import { MapFacilityCard } from './MapFacilityCard'
import { ProgramsFacilityCard } from './ProgramsFacilityCard'
import { RankedFacilityCard } from './RankedFacilityCard'
import {
  DefaultFacilityCardProps,
  MapFacilityCardProps,
  ProgramsFacilityCardProps,
  RankedFacilityCardProps,
} from './types'

export type {
  DefaultFacilityCardProps,
  MapFacilityCardProps,
  ProgramsFacilityCardProps,
  RankedFacilityCardProps,
} from './types'

export type FacilityCardProps =
  | DefaultFacilityCardProps
  | RankedFacilityCardProps
  | MapFacilityCardProps
  | ProgramsFacilityCardProps

/**
 * FacilityCard component
 *
 * Provides smart defaults for the `Card` component
 */
export const FacilityCard = (props: FacilityCardProps) => {
  switch (props.variant) {
    case 'default':
      return <DefaultFacilityCard {...props} />
    case 'ranked':
      return <RankedFacilityCard {...props} />
    case 'map':
      return <MapFacilityCard {...props} />
    case 'programs':
      return <ProgramsFacilityCard {...props} />
    default:
      throw new Error('Invalid `variant` prop provided to FacilityCard')
  }
}
